var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"user-view"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"5","lg":"4"}},[_c('bread-crumbs',{attrs:{"context":{
          workflowTemplateName: _vm.workflowTemplateData.title,
        }}}),_c('workflow-bio-panel')],1),_c('v-col',{attrs:{"cols":"12","md":"7","lg":"8"}},[(_vm.workflowTemplateData.id)?_c('WorkflowTabSteps'):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }